import { render, staticRenderFns } from "./ButtonDialog.vue?vue&type=template&id=54113af3&"
import script from "./ButtonDialog.vue?vue&type=script&lang=js&"
export * from "./ButtonDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports